// Template285: Bali - Aeropuerto (Airports.jsx)
// Cabecera verde, intro, bloques (titulo + lista), sabías que, consejo final.

import React from "react";
import { Box } from "@mui/material";
import { useWindowSize } from "@uidotdev/usehooks";

const Template285 = ({
	backgroundColor,
	textColor,
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
}) => {
	const size = useWindowSize();
	const isSmallScreen = size.width <= 600;

	const headerText = page?.texts?.[0]?.content;
	const intro = page?.texts?.[1]?.content;
	const sabiasQue = page?.texts?.[2]?.content;
	const consejoFinal = page?.texts?.[3]?.content;

	const getImageSrc = (id) => {
		if (page?.images && Array.isArray(page.images)) {
			const found = page.images.find((img) => img?.id === id);
			if (found?.src) return found.src;
		}
		return undefined;
	};
	const getCanvasImageUrl = (id) => {
		if (page?.canvasImages && Array.isArray(page.canvasImages)) {
			const found = page.canvasImages.find((img) => img?.id === id);
			if (found?.imageUrl) return found.imageUrl;
		}
		return undefined;
	};

	const logoImage = getCanvasImageUrl("logo");
	const boxes = Array.isArray(page?.data?.boxes) ? page.data.boxes : [];
	const actualHeaderColor = headerBackgroundColor || "#2F6B4F";
	const contentColor = textColor || "#444";

	const estiloH3 = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: 14,
		fontWeight: 700,
		textTransform: "uppercase",
		margin: 0,
		marginBottom: 1,
		color: "#2F6B4F",
	};
	const estiloP = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: 13,
		color: contentColor,
		margin: 0,
	};

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				height: "100%",
				backgroundColor: backgroundColor || "#f7f7f7",
				color: contentColor,
				fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				"& *:not([data-template-header])": { fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`, color: "inherit" },
			}}
		>
			<Box
				data-block-id="header"
				data-template-header
				sx={{
					backgroundColor: actualHeaderColor,
					color: headerTextColor || "#fff",
					textAlign: "center",
					padding: "15px 0",
					fontSize: "14px",
					fontWeight: 600,
					flexShrink: 0,
					position: "sticky",
					top: 0,
					zIndex: 1,
				}}
			>
				{headerText}
				{logoImage && !isSmallScreen && (
					<Box component="img" src={logoImage} alt="logo" sx={{ width: 66, position: "absolute", right: 2, top: 18, zIndex: 999999 }} />
				)}
			</Box>

			<Box data-block-id="text-1" sx={{ padding: "12px 16px" }}>
				{intro && <Box component="p" sx={estiloP}>{intro}</Box>}
			</Box>

			<Box data-block-id="text-2" sx={{ padding: "0 16px 20px", flex: 1, overflow: "auto", position: "relative" }}>
				{boxes.map((box, i) => (
					<Box
						key={i}
						data-block-id={`text-${i + 3}`}
						sx={{
							backgroundColor: "#c8e6d4",
							border: "2px solid #2F6B4F",
							borderRadius: "16px",
							padding: 2,
							marginBottom: 2,
						}}
					>
						<Box component="h3" sx={{ ...estiloH3, marginTop: 0 }}>{box.titulo}</Box>
						<Box component="ul" sx={{ paddingLeft: 2.25, margin: 0 }}>
							{(box.items || []).map((item, j) => (
								<Box component="li" key={j} sx={estiloP} dangerouslySetInnerHTML={typeof item === "string" && item.includes("<") ? { __html: item } : undefined}>{typeof item === "string" && !item.includes("<") ? item : null}</Box>
							))}
						</Box>
					</Box>
				))}

				{sabiasQue && (
					<Box
						data-block-id="text-sabias"
						sx={{
							backgroundColor: "#fff8db",
							border: "2px solid #f5c400",
							borderRadius: 12,
							padding: "12px 14px",
							fontSize: 12,
							marginTop: 1.25,
						}}
						dangerouslySetInnerHTML={{ __html: sabiasQue }}
					/>
				)}

				{consejoFinal && (
					<Box
						data-block-id="text-consejo"
						sx={{
							backgroundColor: "#c8e6d4",
							border: "2px solid #2F6B4F",
							borderRadius: "16px",
							padding: 2,
							fontSize: 12,
							color: contentColor,
							marginTop: 2,
						}}
					>
						<Box component="h4" sx={{ marginTop: 0, marginBottom: 1, fontSize: 13, color: "#2F6B4F", fontWeight: 700, textTransform: "uppercase" }}>
							💡 Consejo
						</Box>
						<Box component="p" sx={estiloP} dangerouslySetInnerHTML={{ __html: consejoFinal }} />
					</Box>
				)}
			</Box>
		</Box>
	);
};

Template285.thumbnail = "/images/template-1.png";
export default Template285;
